import React, {useCallback,useEffect,useState}from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faStar, faUsers, faClock, faCode, faProjectDiagram,
  faCheckCircle, faDatabase, faServer, faLaptopCode,
  faCertificate, faBriefcase
} from '@fortawesome/free-solid-svg-icons';
import './HeroSection.css';
 
const FullStackWeb = () => {
   const [showModal, setShowModal] = useState(false);
        const [formCourseName, setFormCourseName] = useState('Full Stack Web Developer');
        const [formData, setFormData] = useState({
          fullName: '',
          mobileNumber: '',
          email: '',
        });
      
        const openModal = () => setShowModal(true);
        const closeModal = useCallback(() => {
          setShowModal(false);
          setFormData({ fullName: '', mobileNumber: '', email: '' });
        }, []);
      
        useEffect(() => {
          const handleEsc = (e) => {
            if (e.key === 'Escape') closeModal();
          };
          window.addEventListener('keydown', handleEsc);
          return () => window.removeEventListener('keydown', handleEsc);
        }, [closeModal]);
      
        const handleInputChange = (e) => {
          const { name, value } = e.target;
          if (name === 'mobileNumber') {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 10) {
              setFormData(prev => ({ ...prev, [name]: digitsOnly }));
            }
          } else {
            setFormData(prev => ({ ...prev, [name]: value }));
          }
        };
      
        const handleSubmit = async (e) => {
          e.preventDefault();
          const { fullName, mobileNumber, email } = formData;
      
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
          if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
            alert('Please fill in valid details.');
            return;
          }
      
          try {
            const response = await fetch('https://api.dikshasea.in/api/enrollments', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...formData, course: formCourseName }),
            });
      
            const result = await response.json();
            if (response.ok) {
              alert('Enrollment successful!');
              closeModal();
            } else {
              alert(result.message || 'Submission failed');
            }
          } catch (err) {
            console.error(err);
            alert('Error submitting form');
          }
        };
      
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="hero-title">
                Become a <span className="hero-highlight">Full Stack Web Developer</span>
              </h1>
              <p className="hero-subtitle">
                Master both frontend and backend development with our comprehensive course.
                Learn to build complete web applications using the latest technologies and frameworks.
              </p>
             
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.8/5.0</div>
                    <small className="text-muted">(3,120 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">12,500+</div>
                    <small className="text-muted">Students</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">60 hours</div>
                    <small className="text-muted">Content</small>
                  </div>
                </div>
              </div>
             
             <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img
                  src="subcourses-images/full-stack web.jpg"
                  alt="Full Stack Web Development Course"
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
     <div className="container">
      <div className="course-details">
        <div className="course-content">
          {/* About Course */}
          <section className="about-course">
            <h2 className="section-title">About This Course</h2>
            <p>This intensive Full Stack Web Development program will take you from beginner to job-ready developer. You'll learn to build complete web applications from the ground up, mastering both client-side and server-side technologies.</p>
            <p>Through hands-on projects, you'll gain experience with the same tools and frameworks used by top tech companies worldwide.</p>
          </section>
         
          {/* Curriculum */}
          <section className="curriculum">
            <h2 className="section-title">Curriculum</h2>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faCode} className="me-2" /> Module 1: Frontend Fundamentals</h3>
              <p>Master the core technologies of web development</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> HTML5 and semantic markup</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> CSS3 and responsive design</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> JavaScript (ES6+)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> DOM manipulation</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faLaptopCode} className="me-2" /> Module 2: Frontend Frameworks</h3>
              <p>Build interactive UIs with modern JavaScript frameworks</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> React.js fundamentals</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> State management (Redux)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Component architecture</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> React hooks</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faServer} className="me-2" /> Module 3: Backend Development</h3>
              <p>Create robust server-side applications</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Node.js and Express</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> RESTful API design</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Authentication (JWT, OAuth)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Server-side security</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faDatabase} className="me-2" /> Module 4: Databases</h3>
              <p>Work with both SQL and NoSQL databases</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> MongoDB (NoSQL)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> PostgreSQL (SQL)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Database modeling</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> ORMs (Mongoose, Sequelize)</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 5: Full Stack Integration</h3>
              <p>Bring everything together in a capstone project</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> MERN stack application</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Deployment strategies</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Performance optimization</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Testing (Jest, Cypress)</div>
              </div>
            </div>
          </section>
         
        </div>  
       
        <div className="course-sidebar">
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <div className="info-content">
              <h4>Duration</h4>
              <p>16 Weeks (15 hrs/week)</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faCertificate} />
            </div>
            <div className="info-content">
              <h4>Level</h4>
              <p>Beginner to Advanced</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faLaptopCode} />
            </div>
            <div className="info-content">
              <h4>Projects</h4>
              <p>6 Portfolio Projects</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className="info-content">
              <h4>Prerequisites</h4>
              <p>Basic programming knowledge</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <div className="info-content">
              <h4>Career Support</h4>
              <p>Portfolio reviews, Job placement</p>
            </div>
          </div>
         
          <a href="/register" className="enroll-button" style={{display: 'block', textAlign: 'center', marginTop: '2rem'}}>
            Enroll Now
          </a>
        </div>
      </div>
    </div>
    {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">Full Stack Web Developer</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
 
export default FullStackWeb;